import Link from "next/link";
import { FC } from "react";

import SectionWithTitle from "src/components/SectionWithTitle";
import { Property, SchemaReference } from "src/lib/graphql/types";
import { schemaPath } from "src/lib/schemaOrgUrl";
import FormattedSchemaPath from "./FormattedSchemaPath";

const PropertyMetaLink = ({ name, namespace }: SchemaReference) => (
  <div className="property-meta-link" key={schemaPath({ name, namespace })}>
    <Link href={schemaPath({ name, namespace })}>
      <a className="text-link">
        <FormattedSchemaPath name={name} namespace={namespace} />
      </a>
    </Link>
  </div>
);

const PropertyBody: FC<{
  property: Pick<
    Property,
    "expectedType" | "inverseOf" | "name" | "namespace" | "subPropertyOf"
  > & { propertyOf: SchemaReference[] } & {
    subProperties?: Pick<Property, "id" | "name" | "namespace">[];
  };
}> = ({ property }) => {
  return (
    <div className="schema-body-left property-body">
      <SectionWithTitle title="Expected values">
        {property.expectedType.map((props) => (
          <PropertyMetaLink {...props} key={schemaPath(props)} />
        ))}
      </SectionWithTitle>
      <SectionWithTitle title="Used on these types">
        {property.propertyOf.map((props) => (
          <PropertyMetaLink {...props} key={schemaPath(props)} />
        ))}
      </SectionWithTitle>
      {!!property.subPropertyOf?.length && (
        <SectionWithTitle title="Sub-property of">
          {property.subPropertyOf.map(
            (props) =>
              // 'type' appears as a 'sub-property of' (e.g. additionalType) but has no actual page
              props.name !== "type" && (
                <PropertyMetaLink {...props} key={schemaPath(props)} />
              )
          )}
        </SectionWithTitle>
      )}
      {property.inverseOf && (
        <SectionWithTitle title="Inverse of">
          <PropertyMetaLink
            name={property.inverseOf.name}
            namespace={property.inverseOf.namespace}
            key={schemaPath(property.inverseOf)}
          />
        </SectionWithTitle>
      )}
    </div>
  );
};

export default PropertyBody;
